import { render } from "./IpOSExecutarBairroReportPage.vue?vue&type=template&id=65bafdad"
import script from "./IpOSExecutarBairroReportPage.vue?vue&type=script&lang=js"
export * from "./IpOSExecutarBairroReportPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__